import createLucideIcon from '../createLucideIcon';

/**
 * @component @name ZodiacPisces
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgMjFhMTUgMTUgMCAwIDEgMC0xOCIgLz4KICA8cGF0aCBkPSJNMjAgMTJINCIgLz4KICA8cGF0aCBkPSJNNSAzYTE1IDE1IDAgMCAxIDAgMTgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/zodiac-pisces
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const ZodiacPisces = createLucideIcon('zodiac-pisces', [
  ['path', { d: 'M19 21a15 15 0 0 1 0-18', key: 'br2vug' }],
  ['path', { d: 'M20 12H4', key: '1mtusc' }],
  ['path', { d: 'M5 3a15 15 0 0 1 0 18', key: '1w7hae' }],
]);

export default ZodiacPisces;
